import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText, RefreshCcw, Shield, Truck, ChevronRight } from 'lucide-react';

const POLICIES = [
  {
    to:       '/policies/terms',
    icon:     FileText,
    title:    'Terms & Conditions',
    desc:     'Eligibility, investment rules, payments & account usage',
  },
  {
    to:       '/policies/refund',
    icon:     RefreshCcw,
    title:    'Refund & Cancellation Policy',
    desc:     'How we handle refunds, failed payments & cancellations',
  },
  {
    to:       '/policies/privacy',
    icon:     Shield,
    title:    'Privacy Policy',
    desc:     'What data we collect, how it is used and protected',
  },
  {
    to:       '/policies/shipping',
    icon:     Truck,
    title:    'Shipping & Delivery Policy',
    desc:     'Gold jewellery delivery, pickup, packaging & tracking',
  },
];

export default function PoliciesIndexPage() {
  const navigate = useNavigate();

  return (
    <div className="app-shell flex flex-col min-h-screen">

      {/* Header */}
      <div
        className="sticky top-0 z-20 flex items-center gap-3 px-4 py-4 border-b"
        style={{
          background: 'rgba(15,27,80,0.95)',
          backdropFilter: 'blur(12px)',
          borderColor: 'rgba(212,160,23,0.15)',
        }}
      >
        <button
          onClick={() => navigate(-1)}
          className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: 'rgba(255,255,255,0.08)' }}
        >
          <ArrowLeft size={18} color="rgba(255,255,255,0.8)" />
        </button>
        <div>
          <h1 className="text-base font-serif font-bold text-white">Legal & Policies</h1>
          <p className="text-[11px]" style={{ color: 'rgba(255,255,255,0.4)' }}>
            Shine Jewellery — Merchant Compliance Documents
          </p>
        </div>
      </div>

      {/* Intro */}
      <div className="px-4 pt-5 pb-2">
        <p className="text-sm" style={{ color: 'rgba(255,255,255,0.5)' }}>
          Please read our policies before using the Platform. By investing or transacting on
          Shine Jewellery, you agree to the terms below.
        </p>
      </div>

      {/* Policy Cards */}
      <div className="flex flex-col gap-3 px-4 py-4">
        {POLICIES.map(({ to, icon: Icon, title, desc }, idx) => (
          <motion.div
            key={to}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.06 }}
          >
            <Link
              to={to}
              className="flex items-center gap-4 rounded-2xl p-4 border transition-all active:scale-98"
              style={{
                background: 'rgba(255,255,255,0.05)',
                borderColor: 'rgba(212,160,23,0.2)',
                textDecoration: 'none',
              }}
            >
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: 'linear-gradient(135deg, #d4a017, #f0c040)' }}
              >
                <Icon size={18} color="#fff" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-white">{title}</p>
                <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.45)' }}>{desc}</p>
              </div>
              <ChevronRight size={16} color="rgba(255,255,255,0.3)" />
            </Link>
          </motion.div>
        ))}
      </div>

      {/* Footer */}
      <div
        className="mt-auto px-4 py-6 border-t text-center"
        style={{ borderColor: 'rgba(255,255,255,0.07)' }}
      >
        <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
          © 2026 Shine Jewellery · All Rights Reserved
        </p>
        <p className="text-xs mt-0.5" style={{ color: 'rgba(255,255,255,0.2)' }}>
          support@shinejewellery.in
        </p>
      </div>

    </div>
  );
}
